import { render, staticRenderFns } from "./GreenFitOutRemarks.vue?vue&type=template&id=abc4dc88&scoped=true&"
import script from "./GreenFitOutRemarks.vue?vue&type=script&lang=js&"
export * from "./GreenFitOutRemarks.vue?vue&type=script&lang=js&"
import style0 from "./GreenFitOutRemarks.vue?vue&type=style&index=0&id=abc4dc88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc4dc88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abc4dc88')) {
      api.createRecord('abc4dc88', component.options)
    } else {
      api.reload('abc4dc88', component.options)
    }
    module.hot.accept("./GreenFitOutRemarks.vue?vue&type=template&id=abc4dc88&scoped=true&", function () {
      api.rerender('abc4dc88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/greenFitOut/GreenFitOutRemarks.vue"
export default component.exports